import { render, staticRenderFns } from "./social-info.vue?vue&type=template&id=93e74694&scoped=true&"
import script from "./social-info.vue?vue&type=script&lang=js&"
export * from "./social-info.vue?vue&type=script&lang=js&"
import style0 from "./social-info.vue?vue&type=style&index=0&id=93e74694&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e74694",
  null
  
)

export default component.exports